import { LOAD } from '../load.config'

// LOAD TOP-UP (marked step, item F raised load, 2026-10-07): the real war
// screen can hold up to LOAD.structuresPerHive structures per Hive. When a
// fixture has fewer, this adds single-cell structures until each Hive has
// that many, so the graded scene carries the worst-case structure load.
//
// - Only the graded scene is topped up; criterion #8's fixtures are never
//   touched (they must match the rules output exactly).
// - Added structures are marked `loadTopUp: true`, ids "loadtopup-<side>-<n>",
//   and listed in the returned `added` (logged with every run).
// - Cells are picked deterministically: intact, empty, not a Brood, away
//   from the corridor band (rows 4+), spread across the Hive.
export function topUpStructures(result, perHive = LOAD.structuresPerHive) {
    const out = JSON.parse(JSON.stringify(result))
    const added = []
    for (const [seat, side] of [['p1', 'self'], ['p2', 'opp']]) {
        const hf = out[seat]?.homefront
        if (!hf) continue
        const have = Object.values(hf.structures).filter(st => st.type !== 'base').length
        const need = Math.max(0, perHive - have)
        if (!need) continue
        const busy = new Set()
        for (const st of [...Object.values(hf.structures), ...Object.values(hf.broods ?? {})]) for (const s of st.footprint) busy.add(s)
        // Candidate cells: rows >= 4, intact, empty; spread by striding.
        const free = []
        hf.subplots.forEach((sp, s) => {
            const sr = s % 15
            if (sr >= 4 && !sp.destroyed && !sp.structureId && !sp.broodId && !busy.has(s)) free.push(s)
        })
        const stride = Math.max(1, Math.floor(free.length / (need + 1)))
        for (let i = 0; i < need && i * stride < free.length; i++) {
            const s = free[Math.min(free.length - 1, (i + 1) * stride)]
            const id = `loadtopup-${side}-${i + 1}`
            hf.structures[id] = { id, footprint: [s], rockets: 0, rocketCells: [], loadTopUp: true }
            hf.subplots[s].structureId = id
            added.push({ side, id, s })
        }
    }
    return { result: out, added }
}
